export default "__VITE_ASSET__VNYrzbrn__"